import { InjectionToken } from "@angular/core";

export const TOKEN_STORAGE = new InjectionToken<Storage>('Storage', {
    providedIn: 'root',
    factory: () => localStorage
});
